import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  errorMessage: "",
};

export const fetchError = createAsyncThunk("fetchError", async (message) => {
  return message.data?.responseMessage;
});

export const resetFlagsApi = createAsyncThunk(
  "reset-flag",
  async (moduleName, { dispatch }) => {
    try {
      const response = await axios.put(`/flag?moduleName=${moduleName}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const authSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchError.pending, (state) => {
        state.errorMessage = "";
      })
      .addCase(fetchError.fulfilled, (state, action) => {
        state.errorMessage = action.payload;
      })
      .addCase(fetchError.rejected, (state, action) => {
        state.errorMessage = action.payload;
      });
  },
});

export default authSlice.reducer;
